import api from 'services/api'
import {
  GET_BRANDADS_LIST,
  DELETE_BRANDAD,
  CREATE_BRANDAD,
  UPDATE_BRANDAD,
  GET_BRANDAD_DETAIL,
  GET_BRAND_OPTIONS,
} from '../endpoints'

export const getBrandAdsList = async (body) => await api.post(GET_BRANDADS_LIST, body)
export const getBrandOptions = async () => await api.post(GET_BRAND_OPTIONS)
export const deleteBrandAd = async (id) => await api.delete(DELETE_BRANDAD, {data: {brand_ad_id: id}})
export const getBrandAdDetail = async (id) => await api.get(`${GET_BRANDAD_DETAIL}?brand_ad_id=${id}`)


export const submitBrandAd = async (values, id) =>
  await api.post(id ? UPDATE_BRANDAD : CREATE_BRANDAD, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
